module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', [_c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.$emit("selected")
      }
    }
  }, [_c('v-list-tile-avatar', [(_vm.profilePic) ? _c('img', {
    attrs: {
      "src": _vm.profilePic
    }
  }) : _c('v-icon', [_vm._v("account_circle")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n        " + _vm._s(_vm.practitioner.first_name) + " " + _vm._s(_vm.practitioner.last_name) + "\n      ")])], 1), _vm._v(" "), (_vm.withDropdown) ? _c('v-list-tile-action', [_c('v-icon', [_vm._v("keyboard_arrow_down")])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2211cb35","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/UserStatus.vue
// module id = 1355
// module chunks = 9